import { TimingTokens } from './timings';
import { EasingTokens } from './easings';

export const TransitionTokens = {
  motion: `${TimingTokens.objTransition} ${EasingTokens.easeOutCubic}`,
  prop: `${TimingTokens.propTransition} ${EasingTokens.easeInOut}`,
  propCubic: `${TimingTokens.propTransition} ${EasingTokens.easeOutCubic}`,
  subtle: `${TimingTokens.propTransition} ${EasingTokens.easeOutCubic}`,
};
